import classnames from 'classnames';
import { observer } from 'mobx-react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { BodyText, Button, FormInput, Headline, Stack } from '@servicetitan/design-system';
import { PhoneNumberInput } from '@servicetitan/form';

import { WidgetStore } from '../../stores/widget.store';
import { LoadStatus } from '../../enums/load-status';

import * as Styles from './widget.module.less';

export const Widget = provide({ singletons: [WidgetStore] })(
    observer(() => {
        const [{ formState, handleSubmit, submitStatus }] = useDependencies(WidgetStore);
        const nameField = formState.$.name;
        const phoneField = formState.$.phone;

        return (
            <Stack
                alignItems="flex-end"
                className={classnames(Styles.widgetContainer, 'p-0', 'm-4')}
                justifyContent="center"
            >
                <Stack direction="column">
                    <Headline size="xlarge" className="m-b-2">
                        Subscribe for SMS Updates
                    </Headline>
                    <BodyText className="m-b-4">
                        Get deals, sales and other tips sent to your mobile.
                    </BodyText>
                    <FormInput
                        placeholder="Name"
                        data-cy="user-name"
                        value={nameField.value}
                        error={nameField.error}
                        onChange={nameField.onChangeHandler}
                        label="Name"
                        className="m-b-3"
                    />
                    <PhoneNumberInput
                        className="m-b-3"
                        label="Phone Number"
                        onChange={phoneField.onChangeNativeHandler}
                        value={phoneField.value}
                        error={phoneField.error}
                        placeholder="(xxx)xxx-xxxx"
                    />

                    <Button
                        primary
                        onClick={handleSubmit}
                        disabled={formState.hasError}
                        loading={submitStatus === LoadStatus.Loading}
                        className="m-b-2"
                    >
                        Subscribe
                    </Button>
                    <BodyText subdued>You can later unsubscribe by texting STOP.</BodyText>
                </Stack>
            </Stack>
        );
    })
);
